export const ADD_ROTATION_POSITION = 'ADD_ROTATION_POSITION';
export const ADD_ROTATION_POSITION_SUCCESS = 'ADD_ROTATION_POSITION_SUCCESS';
export const ADD_ROTATION_POSITION_ERROR = 'ADD_ROTATION_POSITION_ERROR';
